import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MultiAtributePopupComponent } from 'app/modules/employee-view/actuaciones/create-actuationes/multi-atribute-popup/multi-atribute-popup.component';
import { CustomFormControl } from 'app/modules/employee-view/entities/customFormControl';
import { EmpresaService } from 'app/modules/employee-view/services/empresa.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'create-employee-attribute',
    templateUrl: './attribute.component.html',
    styleUrls: ['./attribute.component.scss'],
    standalone: false
})
export class AttributeComponent implements OnInit {

  @Input() createNewEmployeeFormGroup: UntypedFormGroup;
  @Input() empresaId: any;
  @Input() empresaDetails: any;

  attributeFormControls: Array<CustomFormControl> = [];

  // working hours control (Jornada)
  workingOurPercant: CustomFormControl;

  constructor(public empresaService: EmpresaService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.empresaId && this.createNewEmployeeFormGroup && this.empresaDetails) {
      this.attributeFormControls = [];
      this.workingOurPercant = this.createNewEmployeeFormGroup.get('WorkingHourPercent') as CustomFormControl;
      this.configure(this.empresaDetails);
    }
  }


  private configure(res: any): void {
    // This block removes the unnecessary attributes for company accroding to company settings.
    const attributeFormGroup = this.configureAttributeForm(res);
    // This block sets the form gropup's attribute validations accroding to company settings.
    if (attributeFormGroup !== null) {
      Object.keys(attributeFormGroup.controls).forEach(controlName => {
        /*NOTE 
        'mandotory' = 'Obligatorio' in database(Ex:- mandotory1=obligatorio1)
        'coinsideAttribute'= 'coincidir' in database(Ex:-coinsideAttribute1=coincidir1)
        'multiAttribute'= 'multiAtributo' in database(Ex:-multiAtributo1=multiAtributo1)
        */

        // get form control
        const formControl: AbstractControl = attributeFormGroup.controls[controlName];

        // get attribute index using control name
        const attributeIndex = controlName.substr(9);

        // create custom control
        const customControl: CustomFormControl = new CustomFormControl();

        // get props of the attribute using the givan index
        const atributo = res[`atributo${attributeIndex}`] as string;
        const obligator = res[`obligatorio${attributeIndex}`] as string;
        const coincidir = res[`coincidir${attributeIndex}`] as string;
        const multiAtributo = res[`multiAtributo${attributeIndex}`] as string;

        //---- set custom control properties

        // set an empty value
        customControl.value = '';

        // custom control name
        customControl.Name = controlName;

        // check if a value is required
        if (obligator !== null && obligator === 'S') {
          formControl.setValidators(Validators.required);
          customControl.Mandotory = true;
        } else {
          formControl.setValidators(null);
          customControl.Mandotory = false;
        }

        // set label as attribute name
        customControl.label = atributo;

        // check multiplicity
        customControl.Multiple = (multiAtributo !== null && multiAtributo === 'S') ? true : false;

        // check drop down properties
        if (coincidir !== null && coincidir === 'S') {
          customControl.Dropdown = true;
          this.populateAttrDropDown(customControl);
        }
        else
          customControl.Dropdown = false;

        // add control form
        this.attributeFormControls.push(customControl);

      });

    }
  }

  configureAttributeForm(res: any): UntypedFormGroup | null {

    const attributeFormGroup = this.createNewEmployeeFormGroup.get('Attributes') as UntypedFormGroup;

    // check each attribute and remove controls if attribute is null
    // or add if attribute is not null and control is not already there
    for (let attributeIndex = 1; attributeIndex < 13; attributeIndex++) {
      const controlName = `Attribute${attributeIndex}`

      if (res[`atributo${attributeIndex}`] === null)
        attributeFormGroup.removeControl(controlName);
      else if (!attributeFormGroup.get(controlName))
        attributeFormGroup.addControl(controlName, new UntypedFormControl());
    }

    return attributeFormGroup;
  }

  private populateAttrDropDown(control: CustomFormControl): void {
    if (control.Dropdown) {
      const index: number = Number(control.Name.substr(9));
      this.empresaService.GetAttributesByIndex(this.empresaId, index)
        .pipe(map(res => {
          return res.result.map(elem => {
            return { text: elem.texto, value: elem.texto };
          });
        }))
        .subscribe(result => {
          result.sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
          control.Options = result;
        }, err => {
          console.error(err);
        });
    }
  }

  openEditMultiAttributePopup(name: string, value: string): void {
    const multiAtributeComponentRef = this.dialog.open(MultiAtributePopupComponent, {
      width: '550px',
      data: { Value: value }
    });
    multiAtributeComponentRef.afterClosed().subscribe(result => {
      if (result) {
        const attributeValue = String(result.finalString).trim();
        this.createNewEmployeeFormGroup.get('Attributes').get(name).patchValue(attributeValue);
        const control = this.attributeFormControls.find(x => x.Name === name);
        control.value = attributeValue;

        // set total working hours
        this.workingOurPercant.value = result.WorkingHourPercent;
      }
    });
  }

}
